import React, { useEffect, useState } from "react";
import UnauthorizedNavbar from "./unauthorizedNavbar";
import UnauthorizedFooter from "./unauthorizedFooter";
import { useNavigate } from "react-router-dom";
import "../newsletter.css";

const CmsPage = ({ type }) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const token = sessionStorage.getItem("jwtToken");
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    setLoading(true);
    fetch(`${BASE_URL}/getCMS/${type}`)
      .then((res) => res.text()) // API returns HTML
      .then((data) => {
        data = data
          .replace(/<header>/g, `<header class="newsletter-header-content">`)
          .replace(/<h1>/g, `<header class="policy-header-content">`)
          .replace(/<h2>/g, `<p class="policy-h2">`)
          .replace(/<entitytable>/g, `<p class="entity-table">`)
          .replace(
            /<p>/g,
            `<p style="margin-bottom:1.5rem; font-size:1.1rem; color:#374151;">`,
          );
        setContent(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching CMS:", err);
        setLoading(false);
      });
  }, [type]); // <- add 'type' here

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  return (
    <>
      <UnauthorizedNavbar />
      <div className="newsletter-page-wrapper">
        <div className="cms-page container mx-auto p-3">
          <div
            className="cms-content prose max-w-none"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
      <UnauthorizedFooter />
    </>
  );
};

export default CmsPage;
